import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../../../core/helpers/isMobile';
import { getGameImages } from '../../../../../core/helpers/getGameImages';

const PayTableStepTitle = observer(({ text, stepId, y }) => {
  const textRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const { payTableTitleRight, payTableTitleLeft } = useMemo(() => {
    return getGameImages();
  }, []);

  const containerHalfPosition = useMemo(() => {
    return stepId ? stepId * 1440 + 720 : 720;
  }, [stepId]);

  useEffect(() => {
    if (textRef.current) {
      setWidth(textRef.current.width);
      setHeight(
        isMobile() && y
          ? y + textRef.current.height / 2
          : !y
          ? y + textRef.current.height / 2 + 124
          : 50
      );
    }
  }, [text, y]);

  return (
    <Container x={0} y={isMobile() ? height : 50} name='PayTableTitleContainer'>
      <Sprite
        x={(isMobile() ? 270 : containerHalfPosition) - width / 2 - 10}
        anchor={{ y: 0.5, x: 1 }}
        texture={payTableTitleRight}
      />
      <Text
        text={text}
        anchor={0.5}
        ref={textRef}
        resolution={2}
        x={isMobile() ? 270 : containerHalfPosition}
        style={{
          _fontSize: isMobile() ? 30 : 40,
          _fontWeight: 700,
          _fill: '#FFFFFF',
          _fontFamily: 'poppinsMedium',
        }}
      />
      <Sprite
        x={(isMobile() ? 270 : containerHalfPosition) + width / 2 + 10}
        anchor={{ y: 0.5 }}
        texture={payTableTitleLeft}
      />
    </Container>
  );
});

export default PayTableStepTitle;
